'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'starship-freighter';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e03a';
var svgPathData = 'M381.4 391.9l-69.3-97.8c5.1-11.7 7.9-24.6 7.9-38.1 0-53-43-96-96-96s-96 43-96 96 43 96 96 96c3.7 0 7.4-.2 11.1-.6l68.6 96.8C279.1 458.4 252.2 464 224 464 109.1 464 16 370.9 16 256S109.1 48 224 48c112.6 0 204.4 89.5 207.9 201.3 .1 4.2 .2 9.2 0 14.6-1.8 48.9-20.5 93.4-50.4 128zM429 408l-36.2 0-1.9-2.6c28.8-32.1 48.4-72.6 54.8-117.4l114.3 0 0 69.1-131 50.9zm43 .4l104-40.4 0-96-128.6 0c.8-10.6 .7-21.4 0-31.8l0-.2 128.6 0 0-96-228.4-88.8C308.2 39.9 266.3 32 224 32 100.3 32 0 132.3 0 256S100.3 480 224 480c31.5 0 62.8-4.4 93-12.9 7.5 10.5 16.2 22.8 26.2 36.9l128.8 0 0-95.6zM447.4 224l-1.7 0c-8.6-60.3-41.3-112.9-88-147.7l202.3 78.7 0 69.1-112.6 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-112a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM341.9 474.5L252.4 347.7c21.2-6.6 39.2-20.2 51.3-38.3l80.8 114.5 71.4 0 0 64-104.6 0-9.6-13.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarshipFreighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;